import { LightMode, ModeNight } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import React from 'react'
import { useAppDispatch } from '../../store/redux/hooks'
import { getCurrentMode, toggleMode } from '../../store/redux/reducers/darkModeSlice'
import { useSelector } from 'react-redux'

const DarkModeButton = () => {
  const dispatch = useAppDispatch()
  const mode = useSelector(getCurrentMode)

  const toggleDarkMode = () => {
    dispatch(toggleMode())
  }

  return (
    <IconButton
      aria-label="Toggle Dark Mode"
      aria-pressed={mode === 'dark'}
      sx={{
        width: 36,
        height: 36,
        color: 'text.base',
        '&:hover': {
          color: 'text.highEmphasis',
        },
      }}
      onClick={toggleDarkMode}
    >
      {mode === 'light' ? (
        <ModeNight
          sx={{
            color: 'text.base',
            animation: 'spin 300ms ease-in',
            '@keyframes spin': {
              '0%': {
                opacity: 0,
                transform: 'scale(0.3) rotate(-180deg)',
              },
              '100%': {
                opacity: 100,
                transform: 'scale(1) rotate(0deg)',
              },
            },
          }}
        />
      ) : (
        <LightMode
          sx={{
            animation: 'spin 300ms  ease-in',
            '@keyframes spin': {
              '0%': {
                opacity: 0,
                transform: 'scale(0.3) rotate(-180deg)',
              },
              '100%': {
                opacity: 100,
                transform: 'scale(1) rotate(0deg)',
              },
            },
          }}
        />
      )}
    </IconButton>
  )
}

export default DarkModeButton
